export default {
  users: [],
  user: {
		id: 1,
    name: 'Júlio',
	},
	error: false,
	loader: false
};